// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js??ref--8-1!../../node_modules/sass-loader/lib/loader.js??ref--8-2!./Custom.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("1935549b", content, false);
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js??ref--8-1!../../node_modules/sass-loader/lib/loader.js??ref--8-2!./Custom.scss", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js??ref--8-1!../../node_modules/sass-loader/lib/loader.js??ref--8-2!./Custom.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./static/css/Custom.scss
// module id = 2420
// module chunks = 0